import React from "react";
import { Checkbox, Input } from "semantic-ui-react";

class Filter extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onChange = this.onChange.bind(this);
    this.setViewingArchived = this.setViewingArchived.bind(this);
    this.filterView = this.filterView.bind(this);

    this.state = {
      viewingArchived: false,
      searchValue: this.props.folder
    };
  }

  filterView() {
    this.props.setFilter(this.state.searchValue);
  }

  onChange(e) {
    e.persist();
    this.setState(
      {
        searchValue: e.target.value
      },
      this.filterView
    );
  }

  setViewingArchived(e, data) {
    let setViewingArchived = this.props.setViewingArchived;
    this.setState(
      {
        viewingArchived: data.checked
      },
      function() {
        setViewingArchived(data.checked);
      }
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <Input type="text" placeholder="Search..." onChange={this.onChange} />
        <Checkbox
          label="View Archived Files"
          toggle
          onChange={this.setViewingArchived}
        />
      </div>
    );
  }
}
export default Filter;



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordFilesFilter.js